import styled from '@emotion/styled'
import * as v from 'variables/styles'

export const ShortListFullDetailContainer = styled.div({
  display: 'flex',
  flex: 1,
  flexDirection: 'column',
  margin: '10px',
})